<script setup>
import VoixMediaField from "./VoixMediaField.vue";
import VoixMediaString from "./VoixMediaString.vue";
defineProps({
  field: { type: Object, required: true },
  currentBreakpoint: { type: String, required: false },
  background: { type: Boolean, required: false },
  loading: { type: String, required: false },
  debug: { type: Boolean, required: false }
});
function getRenderModel(fieldEntry) {
  if (fieldEntry && (typeof fieldEntry === "string" || typeof fieldEntry.value === "string"))
    return "String";
  if (typeof fieldEntry === "object")
    return "Field";
  return void 0;
}
function getRenderType(fieldEntry) {
  const renderModel = getRenderModel(fieldEntry);
  if (renderModel === "String")
    return VoixMediaString;
  if (renderModel === "Field")
    return VoixMediaField;
  return void 0;
}
</script>

<template>
  <template v-for="(media, index) in field" :key="index">
    <component
      :is="getRenderType(media)"
      :field="media"
      :background="background"
      :loading="loading"
      :debug="debug"
      v-bind="$attrs"
      v-on="$attrs"
    />
  </template>
</template>
